import { render } from "./Missions_Icon.vue?vue&type=template&id=5899b9c0&scoped=true"
import script from "./Missions_Icon.vue?vue&type=script&lang=js"
export * from "./Missions_Icon.vue?vue&type=script&lang=js"

import "./Missions_Icon.vue?vue&type=style&index=0&id=5899b9c0&scoped=true&lang=css"

import exportComponent from "../../../../thejourney/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5899b9c0"]])

export default __exports__